module.exports = __webpack_public_path__ + "static/media/like_disabled.00d77f0e.svg";